/*
 * @Author: yangyuanchao
 * @Date: 2021-10-27 13:26
 * @LastEditors: yangyuanchao
 * @Description: 教育积分接口
 * @FilePath: \src\api\EducationalPoints.js
 */
// import requestApi from '@/utils/requestApi'
import requestApi from '@/utils/request'

// 获取当前可用积分数
export function GetPointSum(object, callback = function() {}) {
  return requestApi({ url: 'Point/getPointSum', method: 'post', params: object, keyUrl: true })
    .then(
      res => {
        callback(res)
      }
    ).catch(function(ex) {
      callback({
        code: -2
      })
      console.log('[/C00/DeptList] error: ' + ex)
    })
}
// 获取用户权限
export function GetUserAuthority(object, callback = function() {}) {
  return requestApi({
    url: 'PointAPP/getUserAuthority',
    method: 'post',
    params: object,
    keyUrl: true
  })
    .then(
      res => {
        callback(res)
      }
    ).catch(function(ex) {
      callback({
        code: -2
      })
      console.log('[/C00/DeptList] error: ' + ex)
    })
}

// 获取社内所有在职员工
export function GetAllUser(callback = function() {}) {
  return requestApi({ url: 'O00_PointApvl/getAllUser', method: 'post', keyUrl: true })
    .then(
      res => {
        callback(res)
      }
    ).catch(function(ex) {
      callback({
        code: -2
      })
      console.log('[/C00/DeptList] error: ' + ex)
    })
}

// 获取审批人
export function GetApprovalUser(callback = function() {}) {
  return requestApi({ url: 'PointAPP/getApprovalUser', method: 'post', keyUrl: true })
    .then(
      res => {
        callback(res)
      }
    ).catch(function(ex) {
      callback({
        code: -2
      })
      console.log('[/C00/DeptList] error: ' + ex)
    })
}
// 申请积分
export function AddPointApplyInfo(object, callback = function() {}) {
  return requestApi({
    url: 'Point/addPointApplyInfo',
    method: 'post',
    data: object,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    keyUrl: true,
    contenttype: true
  }).then(
    res => {
      callback(res)
    }
  ).catch(function(ex) {
    callback({
      code: -2
    })
    alert('[/C00/DeptList] error: ' + ex)
  })
}
// 获取积分申请信息
export function GetPointApplyInfo(object, callback = function() {}) {
  return requestApi({
    url: 'PointAPP/point/GetPointApplyInfo',
    method: 'post',
    params: object,
    keyUrl: true
  }).then(
    res => {
      callback(res)
    }
  ).catch(function(ex) {
    callback({
      code: -2
    })
    console.log('[/C00/DeptList] error: ' + ex)
  })
}

// 审批处理
export function IpdApprovalStatusMobile(object, callback = function() {}) {
  return requestApi({
    url: 'O00_PointApvl/IpdApprovalStatusMobile',
    method: 'post',
    data: object,
    keyUrl: true
  }).then(
    res => {
      callback(res)
    }
  ).catch(function(ex) {
    callback({
      code: -2
    })
    console.log('[/C00/DeptList] error: ' + ex)
  })
}
// 文件下载
export function DownloadFile(object, callback = function() {}) {
  return requestApi({
    url: 'PointAPP/downloadFile',
    method: 'post',
    params: object,
    keyUrl: true
  }).then(
    res => {
      callback(res)
    }
  ).catch(function(ex) {
    callback({
      code: -2
    })
    console.log('[/C00/DeptList] error: ' + ex)
  })
}
// 获取积分记录信息
export function GetPointInfo(object, callback = function() {}) {
  return requestApi({
    url: 'Point/GetPointInfo',
    method: 'post',
    params: object,
    keyUrl: true
  }).then(
    res => {
      callback(res)
    }
  ).catch(function(ex) {
    callback({
      code: -2
    })
    console.log('[/C00/DeptList] error: ' + ex)
  })
}
// 删除积分申请信息
export function DelPointApplyInfo(object, callback = function() {}) {
  return requestApi({
    url: 'PointAPP/delPointApplyInfo',
    method: 'post',
    params: object,
    keyUrl: true
  }).then(
    res => {
      callback(res)
    }
  ).catch(function(ex) {
    callback({
      code: -2
    })
    console.log('[/C00/DeptList] error: ' + ex)
  })
}
// 更新积分申请信息
export function UpdPointApplyInfo(object, callback = function() {}) {
  return requestApi({
    url: 'PointAPP/updPointApplyInfo',
    method: 'post',
    data: object,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    keyUrl: true,
    contenttype: true
  }).then(
    res => {
      callback(res)
    }
  ).catch(function(ex) {
    callback({
      code: -2
    })
    alert('[/PointAPP/updPointApplyInfo] error: ' + ex)
  })
}
// base64
export function DownloadFileMobile(object, callback = function() {}) {
  return requestApi({
    url: 'PointAPP/downloadFileMobile',
    method: 'post',
    params: object,
    keyUrl: true
  }).then(
    res => {
      callback(res)
    }
  ).catch(function(ex) {
    callback({
      code: -2
    })
    console.log('[/C00/DeptList] error: ' + ex)
  })
}
